/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_PosterInputs */

const en_landing_showcase_poster = /** @type {(inputs: Landing_Showcase_PosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exhibition poster`)
};

const zh_landing_showcase_poster = /** @type {(inputs: Landing_Showcase_PosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展览海报`)
};

/**
* | output |
* | --- |
* | "Exhibition poster" |
*
* @param {Landing_Showcase_PosterInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_poster = /** @type {((inputs?: Landing_Showcase_PosterInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_PosterInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_poster(inputs)
	return zh_landing_showcase_poster(inputs)
});
export { landing_showcase_poster as "landing.showcase.poster" }